import { Entry } from 'network/response/ICart';
import { isNonEmptyObject } from 'utils/helpers.util';

export const getFormattedExpressDeliverySlot = (expressDeliverySlot: any) => {
  if (!expressDeliverySlot || !isNonEmptyObject(expressDeliverySlot)) {
    return '';
  }

  const { beginTime = '', endTime = '' } = expressDeliverySlot;

  return `${beginTime.replace(/\s/g, '')}_${endTime.replace(/\s/g, '')}`;
};

export const getExpressEntries = (entries: Entry[]) =>
  entries.filter(entry => entry.product.isExpressProduct);
